import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal mx-6 pt-6"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-actions"
};
const _hoisted_4 = ["disabled"];
const _hoisted_5 = {
  class: "mx-6 mb-3 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4"
};
const _hoisted_6 = {
  class: "list-page-table-panel list-page-table-panel--fill mx-6"
};
const _hoisted_7 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_8 = {
  class: "data-table-shell"
};
const _hoisted_9 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_10 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "data-table-td"
};
const _hoisted_13 = {
  class: "font-medium text-slate-900"
};
const _hoisted_14 = {
  class: "font-mono text-xs text-slate-500"
};
const _hoisted_15 = {
  class: "data-table-td"
};
const _hoisted_16 = {
  class: "data-table-td"
};
const _hoisted_17 = {
  class: "text-xs text-slate-500"
};
const _hoisted_18 = {
  class: "data-table-td"
};
const _hoisted_19 = {
  class: "text-xs text-slate-500"
};
const _hoisted_20 = {
  class: "data-table-td"
};
const _hoisted_21 = {
  class: "flex flex-wrap gap-1.5"
};
const _hoisted_22 = {
  class: "data-table-td"
};
const _hoisted_23 = {
  class: "data-table-td text-xs text-slate-600"
};
const _hoisted_24 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_25 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  key: 0,
  class: "space-y-5"
};
const _hoisted_28 = {
  class: "rounded-lg border border-slate-200 bg-white p-4"
};
const _hoisted_29 = {
  class: "flex flex-wrap items-start justify-between gap-4"
};
const _hoisted_30 = {
  class: "text-base font-semibold text-slate-900"
};
const _hoisted_31 = {
  class: "mt-2 flex flex-wrap items-center gap-2"
};
const _hoisted_32 = {
  class: "flex flex-wrap gap-2"
};
const _hoisted_33 = {
  class: "grid grid-cols-1 gap-4 md:grid-cols-4"
};
const _hoisted_34 = {
  class: "rounded-lg border border-slate-200 p-4"
};
const _hoisted_35 = {
  class: "mt-2 text-lg money-text text-slate-900"
};
const _hoisted_36 = {
  class: "rounded-lg border border-slate-200 p-4"
};
const _hoisted_37 = {
  class: "mt-2 text-lg money-text text-slate-900"
};
const _hoisted_38 = {
  class: "rounded-lg border border-slate-200 p-4"
};
const _hoisted_39 = {
  class: "mt-2 text-lg money-text text-slate-900"
};
const _hoisted_40 = {
  class: "rounded-lg border border-slate-200 p-4"
};
const _hoisted_41 = {
  class: "mt-2 text-lg money-text text-slate-900"
};
const _hoisted_42 = {
  class: "border-b border-slate-200"
};
const _hoisted_43 = {
  class: "-mb-px flex flex-wrap gap-5 text-sm"
};
const _hoisted_44 = ["onClick"];
const _hoisted_45 = {
  class: "space-y-5"
};
const _hoisted_46 = {
  class: "grid grid-cols-1 gap-4 rounded-lg border border-slate-200 p-4 md:grid-cols-4"
};
const _hoisted_47 = {
  class: "space-y-4"
};
const _hoisted_48 = {
  class: "rounded-lg border border-slate-200 bg-white"
};
const _hoisted_49 = {
  class: "flex items-center justify-between gap-3 border-b border-slate-200 px-4 py-3"
};
const _hoisted_50 = ["disabled"];
const _hoisted_51 = {
  class: "data-table-shell border-0 shadow-none wealth-contract-table-layout"
};
const _hoisted_52 = {
  class: "data-table-scroll wealth-contract-table-scroll"
};
const _hoisted_53 = {
  class: "data-table text-sm"
};
const _hoisted_54 = {
  key: 0
};
const _hoisted_55 = {
  key: 1
};
const _hoisted_56 = {
  class: "data-table-row"
};
const _hoisted_57 = {
  class: "data-table-td"
};
const _hoisted_58 = ["onClick"];
const _hoisted_59 = {
  class: "font-mono text-xs text-slate-500"
};
const _hoisted_60 = {
  key: 0,
  class: "contract-row-ongoing-approval mt-2 flex flex-wrap gap-1.5"
};
const _hoisted_61 = ["onClick"];
const _hoisted_62 = ["onClick"];
const _hoisted_63 = {
  class: "data-table-td is-right money-text"
};
const _hoisted_64 = {
  class: "data-table-td"
};
const _hoisted_65 = {
  class: "data-table-td"
};
const _hoisted_66 = {
  class: "data-table-td is-center"
};
const _hoisted_67 = {
  class: "flex justify-center gap-1"
};
const _hoisted_68 = ["onClick"];
const _hoisted_69 = ["onClick"];
const _hoisted_70 = ["onClick"];
const _hoisted_71 = {
  key: 0
};
const _hoisted_72 = {
  colspan: "5",
  class: "bg-slate-50 p-4"
};
const _hoisted_73 = {
  class: "space-y-4"
};
const _hoisted_74 = {
  class: "flex justify-center gap-1"
};
const _hoisted_75 = ["onClick"];
const _hoisted_76 = ["onClick"];
const _hoisted_77 = {
  class: "space-y-4"
};
const _hoisted_78 = {
  class: "rounded-lg border border-slate-200 bg-white"
};
const _hoisted_79 = {
  class: "flex flex-wrap items-end justify-between gap-3 border-b border-slate-200 px-4 py-3"
};
const _hoisted_80 = {
  class: "flex flex-wrap items-end gap-2"
};
const _hoisted_81 = ["disabled"];
const _hoisted_82 = {
  class: "data-table-shell border-0 shadow-none"
};
const _hoisted_83 = {
  class: "data-table-scroll"
};
const _hoisted_84 = {
  class: "data-table text-sm"
};
const _hoisted_85 = {
  key: 1
};
const _hoisted_86 = {
  class: "data-table-td"
};
const _hoisted_87 = {
  class: "font-mono text-xs"
};
const _hoisted_88 = {
  class: "font-mono text-xs text-slate-500"
};
const _hoisted_89 = {
  class: "data-table-td"
};
const _hoisted_90 = {
  class: "data-table-td"
};
const _hoisted_91 = {
  class: "data-table-td"
};
const _hoisted_92 = {
  class: "text-xs text-slate-500"
};
const _hoisted_93 = {
  class: "data-table-td is-right"
};
const _hoisted_94 = {
  class: "data-table-td text-xs"
};
const _hoisted_95 = {
  class: "data-table-td is-center"
};
const _hoisted_96 = ["onClick"];
const _hoisted_97 = {
  class: "space-y-4"
};
const _hoisted_98 = {
  class: "rounded-lg border border-slate-200 bg-white"
};
const _hoisted_99 = {
  class: "flex flex-wrap items-end justify-between gap-3 border-b border-slate-200 px-4 py-3"
};
const _hoisted_100 = {
  class: "flex flex-wrap items-end gap-2"
};
const _hoisted_101 = ["disabled"];
const _hoisted_102 = {
  class: "data-table-shell border-0 shadow-none"
};
const _hoisted_103 = {
  class: "data-table-scroll"
};
const _hoisted_104 = {
  class: "data-table text-sm"
};
const _hoisted_105 = {
  key: 1
};
const _hoisted_106 = {
  class: "data-table-td"
};
const _hoisted_107 = {
  class: "font-mono text-xs text-slate-900"
};
const _hoisted_108 = {
  class: "mt-1 flex items-center gap-2 text-xs text-slate-500"
};
const _hoisted_109 = ["onClick"];
const _hoisted_110 = {
  class: "data-table-td"
};
const _hoisted_111 = {
  class: "data-table-td is-right"
};
const _hoisted_112 = {
  class: "data-table-td"
};
const _hoisted_113 = {
  class: "data-table-td text-xs"
};
const _hoisted_114 = {
  class: "data-table-td is-center"
};
const _hoisted_115 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_116 = ["onClick"];
const _hoisted_117 = ["onClick"];
const _hoisted_118 = {
  key: 0,
  class: "space-y-5"
};
const _hoisted_119 = {
  class: "grid grid-cols-1 gap-4 rounded-lg border border-slate-200 p-4 md:grid-cols-4"
};
const _hoisted_120 = {
  class: "font-medium"
};
const _hoisted_121 = {
  class: "rounded-lg border border-slate-200"
};
const _hoisted_122 = {
  class: "data-table-shell border-0 shadow-none"
};
const _hoisted_123 = {
  class: "data-table-scroll"
};
const _hoisted_124 = {
  class: "data-table text-sm"
};
const _hoisted_125 = {
  key: 0
};
const _hoisted_126 = {
  class: "data-table-td"
};
const _hoisted_127 = {
  class: "data-table-td is-right"
};
const _hoisted_128 = {
  class: "data-table-td is-right"
};
const _hoisted_129 = {
  class: "space-y-4"
};
const _hoisted_130 = {
  class: "rounded-lg border border-slate-200 bg-white"
};
const _hoisted_131 = {
  class: "flex items-center justify-between border-b border-slate-200 px-4 py-3"
};
const _hoisted_132 = ["disabled"];
const _hoisted_133 = {
  class: "data-table-shell border-0 shadow-none"
};
const _hoisted_134 = {
  class: "data-table-scroll"
};
const _hoisted_135 = {
  class: "data-table text-sm"
};
const _hoisted_136 = {
  key: 0
};
const _hoisted_137 = {
  key: 1
};
const _hoisted_138 = {
  class: "data-table-td"
};
const _hoisted_139 = {
  class: "font-mono text-xs"
};
const _hoisted_140 = {
  class: "font-mono text-xs text-slate-500"
};
const _hoisted_141 = {
  class: "data-table-td"
};
const _hoisted_142 = {
  class: "data-table-td"
};
const _hoisted_143 = {
  class: "data-table-td is-right font-medium"
};
const _hoisted_144 = {
  class: "data-table-td text-xs"
};
const _hoisted_145 = {
  class: "data-table-td is-center"
};
const _hoisted_146 = ["onClick"];
const _hoisted_147 = {
  key: 0,
  class: "space-y-5"
};
const _hoisted_148 = {
  class: "flex justify-end"
};
const _hoisted_149 = {
  class: "grid grid-cols-1 gap-4 rounded-lg border border-slate-200 p-4 md:grid-cols-4"
};
const _hoisted_150 = {
  class: "font-medium"
};
const _hoisted_151 = {
  class: "font-medium"
};
const _hoisted_152 = {
  class: "text-red-600"
};
const _hoisted_153 = {
  class: "rounded-lg border border-slate-200"
};
const _hoisted_154 = {
  class: "data-table-shell border-0 shadow-none"
};
const _hoisted_155 = {
  class: "data-table-scroll"
};
const _hoisted_156 = {
  class: "data-table text-sm"
};
const _hoisted_157 = {
  key: 0
};
const _hoisted_158 = {
  class: "data-table-td"
};
const _hoisted_159 = {
  class: "font-mono text-xs"
};
const _hoisted_160 = {
  class: "data-table-td is-right"
};
const _hoisted_161 = {
  class: "data-table-td is-right"
};
const _hoisted_162 = {
  class: "data-table-td"
};
import { computed, defineComponent, h, reactive, ref, onMounted, onBeforeUnmount, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ApprovalDetailModal from '@/components/ApprovalDetailModal.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import DeptSelector from '@/components/DeptSelector/index.vue';
import { getCustomer } from '@/api/customer';
import { disableWealthCustomer, enableWealthCustomer, getWealthCustomerAccount, getWealthCustomerContractPage, getWealthCustomerPage, getWealthBatchLedgerPage, getWealthFundLedgerBatchDetails, getWealthFundLedgerPage, getWealthOperationApplyBatchDetails, getWealthOperationApplyPage, getWealthStatisticsOverview } from '@/api/wealth';
import WealthAttachmentPanel from '../components/WealthAttachmentPanel.vue';
import WealthBatchPanel from '../components/WealthBatchPanel.vue';
import WealthCustomerFormModal from '../components/WealthCustomerFormModal.vue';
import WealthDetailDrawer from '../components/WealthDetailDrawer.vue';
import WealthMetricCard from '../components/WealthMetricCard.vue';
import WealthOperationApplyModal from '../components/WealthOperationApplyModal.vue';
import WealthStatusBadge from '../components/WealthStatusBadge.vue';
import { applyStatusOptions, cleanPayload, customerStatusOptions, findOptionLabel, formatDate, formatDateTime, formatMoney, idTypeOptions, maskIdNo, maskPhone, operationTypeOptions, PAGE_SIZE_OPTIONS, pagePayload, riskLevelOptions, syncPageResult } from '../utils';
const WEALTH_CUSTOMER_AUTO_REFRESH_INTERVAL_MS = 15000;
export default {
  __name: 'index',
  setup(__props) {
    const FieldBlock = defineComponent({
      name: 'FieldBlock',
      props: {
        label: {
          type: String,
          required: true
        },
        value: {
          type: [String, Number],
          default: '-'
        }
      },
      setup(props) {
        return () => h('div', [h('div', {
          class: 'text-xs text-slate-500'
        }, props.label), h('div', {
          class: 'mt-1 text-sm text-slate-700'
        }, props.value || '-')]);
      }
    });
    const filters = reactive({
      keyword: '',
      status: '',
      riskLevel: '',
      ownerUserId: null,
      ownerDept: null
    });
    const pagination = reactive({
      current: 1,
      page: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const rows = ref([]);
    const loading = ref(false);
    const overview = ref({});
    const statisticsLoading = ref(false);
    const lastAutoRefreshAt = ref(0);
    const formVisible = ref(false);
    const editingCustomer = ref(null);
    const detailVisible = ref(false);
    const selectedCustomer = ref(null);
    const linkedCrmCustomer = ref(null);
    const activeTab = ref('overview');
    const detailTabs = [{
      value: 'overview',
      label: '概览'
    }, {
      value: 'contracts',
      label: '合同'
    }, {
      value: 'ledgers',
      label: '流水'
    }, {
      value: 'applies',
      label: '申请记录'
    }];
    const account = ref({});
    const contracts = ref([]);
    const contractsLoading = ref(false);
    const contractPagination = reactive({
      current: 1,
      page: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const expandedContractId = ref(null);
    const contractOngoingOperationMap = ref({});
    const batchOngoingOperationMap = ref({});
    const ledgers = ref([]);
    const ledgersLoading = ref(false);
    const ledgerFilters = reactive({
      operationType: ''
    });
    const ledgerPagination = reactive({
      current: 1,
      page: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const ledgerDetailVisible = ref(false);
    const selectedLedger = ref(null);
    const ledgerDetails = ref([]);
    const batchLedgerVisible = ref(false);
    const selectedBatchLedgerBatch = ref(null);
    const batchLedgers = ref([]);
    const batchLedgersLoading = ref(false);
    const batchLedgerPagination = reactive({
      current: 1,
      page: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const applies = ref([]);
    const appliesLoading = ref(false);
    const applyFilters = reactive({
      status: ''
    });
    const applyPagination = reactive({
      current: 1,
      page: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const applyDetailVisible = ref(false);
    const selectedApply = ref(null);
    const applyDetails = ref([]);
    const showApprovalDetailModal = ref(false);
    const selectedApprovalInstanceId = ref(null);
    const applyVisible = ref(false);
    const applyType = ref('INVEST');
    const applyPreset = ref({});
    const ongoingApplyStatuses = ['SUBMITTING', 'APPROVING', 'ACCOUNT_FAILED'];
    const linkedCrmCustomerDisplay = computed(() => {
      const linkedId = selectedCustomer.value?.linkedCrmCustomerId;
      if (!linkedId) return '-';
      const customer = linkedCrmCustomer.value;
      if (customer?.id === linkedId) {
        return formatCrmCustomerLabel(customer);
      }
      return `CRM客户 ${linkedId}`;
    });
    function extractId(value) {
      if (Array.isArray(value)) {
        return extractId(value[0]);
      }
      if (value && typeof value === 'object') {
        return value.id;
      }
      return value || null;
    }
    function customerQueryPayload() {
      return cleanPayload({
        keyword: filters.keyword,
        status: filters.status,
        riskLevel: filters.riskLevel,
        ownerUserId: extractId(filters.ownerUserId),
        ownerDeptId: extractId(filters.ownerDept)
      });
    }
    async function loadStatistics() {
      statisticsLoading.value = true;
      try {
        overview.value = (await getWealthStatisticsOverview()) || {};
      } finally {
        statisticsLoading.value = false;
      }
    }
    async function loadCustomers() {
      loading.value = true;
      try {
        const result = await getWealthCustomerPage(pagePayload(pagination, customerQueryPayload()));
        rows.value = result?.records || [];
        syncPageResult(pagination, result);
      } finally {
        loading.value = false;
      }
    }
    async function refreshCustomerListAndStatistics() {
      await Promise.all([loadCustomers(), loadStatistics()]);
    }
    async function refreshWealthCustomerSnapshot() {
      await loadStatistics();
      if (!detailVisible.value || !selectedCustomer.value?.id) return;
      await Promise.all([loadAccount(selectedCustomer.value.id), loadContracts()]);
      if (activeTab.value === 'ledgers') {
        await loadLedgers();
      }
      if (activeTab.value === 'applies') {
        await loadApplies();
      }
    }
    function handleCustomerPageAutoRefresh() {
      if (document.visibilityState !== 'visible') return;
      const now = Date.now();
      if (now - lastAutoRefreshAt.value < WEALTH_CUSTOMER_AUTO_REFRESH_INTERVAL_MS) return;
      lastAutoRefreshAt.value = now;
      refreshWealthCustomerSnapshot();
    }
    function handleSearch() {
      pagination.current = 1;
      pagination.page = 1;
      loadCustomers();
    }
    function handleReset() {
      Object.assign(filters, {
        keyword: '',
        status: '',
        riskLevel: '',
        ownerUserId: null,
        ownerDept: null
      });
      handleSearch();
    }
    function handlePageChange(page) {
      pagination.current = page;
      pagination.page = page;
      loadCustomers();
    }
    function handleSizeChange(size) {
      pagination.size = size;
      handleSearch();
    }
    function openCreate() {
      editingCustomer.value = null;
      formVisible.value = true;
    }
    function openEdit(row) {
      editingCustomer.value = {
        ...row
      };
      formVisible.value = true;
    }
    async function changeStatus(row, action) {
      try {
        await ElMessageBox.confirm(`确认${action === 'disable' ? '停用' : '启用'}客户“${row.name}”吗？`, '状态变更', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        });
        if (action === 'disable') {
          await disableWealthCustomer(row.id, {});
          ElMessage.success('客户已停用');
        } else {
          await enableWealthCustomer(row.id, {});
          ElMessage.success('客户已启用');
        }
        loadCustomers();
        loadStatistics();
      } catch (error) {
        if (error !== 'cancel') console.error(error);
      }
    }
    async function openDetail(row) {
      selectedCustomer.value = row;
      detailVisible.value = true;
      activeTab.value = 'overview';
      account.value = {};
      linkedCrmCustomer.value = null;
      contracts.value = [];
      ledgers.value = [];
      applies.value = [];
      expandedContractId.value = null;
      resetDetailPagination();
      await Promise.all([loadAccount(row.id), loadContracts(), loadLinkedCrmCustomer(row)]);
    }
    function resetDetailPagination() {
      Object.assign(contractPagination, {
        current: 1,
        page: 1,
        size: 10,
        total: 0,
        pages: 1
      });
      Object.assign(ledgerPagination, {
        current: 1,
        page: 1,
        size: 10,
        total: 0,
        pages: 1
      });
      Object.assign(applyPagination, {
        current: 1,
        page: 1,
        size: 10,
        total: 0,
        pages: 1
      });
      Object.assign(ledgerFilters, {
        operationType: ''
      });
      Object.assign(applyFilters, {
        status: ''
      });
    }
    async function loadAccount(customerId) {
      account.value = (await getWealthCustomerAccount(customerId)) || {};
    }
    function formatCrmCustomerLabel(customer = {}) {
      return [customer.name, customer.phone || customer.mobile || customer.customerNo].filter(Boolean).join(' / ') || `CRM客户 ${customer.id}`;
    }
    async function loadLinkedCrmCustomer(row) {
      linkedCrmCustomer.value = null;
      if (!row?.linkedCrmCustomerId) return;
      linkedCrmCustomer.value = {
        id: row.linkedCrmCustomerId,
        name: row.linkedCrmCustomerName || `CRM客户 ${row.linkedCrmCustomerId}`,
        phone: row.linkedCrmCustomerMobile || ''
      };
      try {
        const customer = await getCustomer(row.linkedCrmCustomerId);
        if (customer?.id === row.linkedCrmCustomerId) {
          linkedCrmCustomer.value = customer;
        }
      } catch (error) {
        console.error('load linked CRM customer failed:', error);
      }
    }
    async function loadContracts() {
      if (!selectedCustomer.value?.id) return;
      contractsLoading.value = true;
      try {
        const result = await getWealthCustomerContractPage(selectedCustomer.value.id, pagePayload(contractPagination));
        contracts.value = result?.records || [];
        syncPageResult(contractPagination, result);
        await loadOngoingOperationsForVisibleContracts();
      } finally {
        contractsLoading.value = false;
      }
    }
    function handleContractPageChange(page) {
      contractPagination.current = page;
      contractPagination.page = page;
      loadContracts();
    }
    function handleContractSizeChange(size) {
      contractPagination.size = size;
      contractPagination.current = 1;
      contractPagination.page = 1;
      loadContracts();
    }
    function toggleContract(contract) {
      if (expandedContractId.value === contract.id) {
        expandedContractId.value = null;
        return;
      }
      expandedContractId.value = contract.id;
      loadOngoingOperationsForContract(contract.id);
    }
    async function loadLedgers() {
      if (!selectedCustomer.value?.id) return;
      ledgersLoading.value = true;
      try {
        const result = await getWealthFundLedgerPage(pagePayload(ledgerPagination, cleanPayload({
          wealthCustomerId: selectedCustomer.value.id,
          operationType: ledgerFilters.operationType
        })));
        ledgers.value = result?.records || [];
        syncPageResult(ledgerPagination, result);
      } finally {
        ledgersLoading.value = false;
      }
    }
    function handleLedgerPageChange(page) {
      ledgerPagination.current = page;
      ledgerPagination.page = page;
      loadLedgers();
    }
    function handleLedgerSizeChange(size) {
      ledgerPagination.size = size;
      ledgerPagination.current = 1;
      ledgerPagination.page = 1;
      loadLedgers();
    }
    async function openLedgerDetail(row) {
      selectedLedger.value = row;
      batchLedgerVisible.value = false;
      ledgerDetailVisible.value = true;
      ledgerDetails.value = await getWealthFundLedgerBatchDetails(row.id);
    }
    async function openBatchLedgerDetail(batch) {
      selectedBatchLedgerBatch.value = batch;
      batchLedgerVisible.value = true;
      Object.assign(batchLedgerPagination, {
        current: 1,
        page: 1,
        size: 10,
        total: 0,
        pages: 1
      });
      await loadBatchLedgers(batch);
    }
    async function loadBatchLedgers(batch = selectedBatchLedgerBatch.value) {
      if (!batch?.id) return;
      batchLedgersLoading.value = true;
      try {
        const result = await getWealthBatchLedgerPage(batch.id, pagePayload(batchLedgerPagination));
        batchLedgers.value = result?.records || [];
        syncPageResult(batchLedgerPagination, result);
      } finally {
        batchLedgersLoading.value = false;
      }
    }
    function handleBatchLedgerPageChange(page) {
      batchLedgerPagination.current = page;
      batchLedgerPagination.page = page;
      loadBatchLedgers();
    }
    function handleBatchLedgerSizeChange(size) {
      batchLedgerPagination.size = size;
      batchLedgerPagination.current = 1;
      batchLedgerPagination.page = 1;
      loadBatchLedgers();
    }
    async function loadApplies() {
      if (!selectedCustomer.value?.id) return;
      appliesLoading.value = true;
      try {
        const result = await getWealthOperationApplyPage(pagePayload(applyPagination, cleanPayload({
          wealthCustomerId: selectedCustomer.value.id,
          status: applyFilters.status
        })));
        applies.value = result?.records || [];
        syncPageResult(applyPagination, result);
      } finally {
        appliesLoading.value = false;
      }
    }
    function handleApplyPageChange(page) {
      applyPagination.current = page;
      applyPagination.page = page;
      loadApplies();
    }
    function handleApplySizeChange(size) {
      applyPagination.size = size;
      applyPagination.current = 1;
      applyPagination.page = 1;
      loadApplies();
    }
    async function openApplyDetail(row) {
      selectedApply.value = row;
      applyDetailVisible.value = true;
      applyDetails.value = await getWealthOperationApplyBatchDetails(row.id);
    }
    function openApprovalDetail(row) {
      if (!row?.approvalInstanceId) {
        ElMessage.warning('暂无审批实例');
        return;
      }
      selectedApprovalInstanceId.value = row.approvalInstanceId;
      showApprovalDetailModal.value = true;
    }
    function openOngoingOperationDetail(operation) {
      if (operation?.apply) {
        openApplyDetail(operation.apply);
      }
    }
    function openOngoingOperationApprovalDetail(operation) {
      if (operation?.apply) {
        openApprovalDetail(operation.apply);
      }
    }
    function loadOngoingOperationsForVisibleContracts() {
      return Promise.all(contracts.value.map(contract => loadOngoingOperationsForContract(contract.id)));
    }
    async function loadOngoingOperationsForContract(contractId) {
      const results = await Promise.all(ongoingApplyStatuses.map(status => getWealthOperationApplyPage({
        page: 1,
        size: 100,
        contractId,
        status
      })));
      const applies = results.flatMap(result => result?.records || []);
      const contractOperations = [];
      const nextBatchMap = {};
      await Promise.all(applies.map(async apply => {
        const summary = toOngoingOperationSummary(apply);
        contractOperations.push(summary);
        let details = [];
        try {
          details = await getWealthOperationApplyBatchDetails(apply.id);
        } catch (error) {
          console.error(error);
        }
        if (details.length === 0 && apply.targetBatchId) {
          details = [{
            batchId: apply.targetBatchId,
            amount: apply.rolloverPrincipalAmount || apply.amount
          }];
        }
        details.forEach(detail => {
          if (!detail.batchId) return;
          nextBatchMap[detail.batchId] = nextBatchMap[detail.batchId] || [];
          nextBatchMap[detail.batchId].push(toOngoingOperationSummary(apply, detail));
        });
      }));
      contractOngoingOperationMap.value = {
        ...contractOngoingOperationMap.value,
        [contractId]: contractOperations
      };
      batchOngoingOperationMap.value = nextBatchMap;
    }
    function toOngoingOperationSummary(apply, detail = null) {
      return {
        apply,
        applyId: apply.id,
        applyNo: apply.applyNo,
        batchId: detail?.batchId || apply.targetBatchId,
        operationType: apply.operationType,
        operationTypeLabel: findOptionLabel(operationTypeOptions, apply.operationType),
        status: apply.status,
        statusLabel: findOptionLabel(applyStatusOptions, apply.status),
        amount: detail?.amount || apply.rolloverPrincipalAmount || apply.amount,
        applyTime: apply.applyTime
      };
    }
    function formatOngoingOperationSummary(operation = {}) {
      const amount = operation.amount ? ` ¥${formatMoney(operation.amount)}` : '';
      return `${operation.operationTypeLabel || operation.operationType || '操作'} ${operation.statusLabel || operation.status || ''}${amount} · ${operation.applyNo || '-'}`;
    }
    function openInvest(customer) {
      applyType.value = 'INVEST';
      applyPreset.value = {
        wealthCustomerId: customer.id,
        customerName: customer.name
      };
      applyVisible.value = true;
    }
    function openContractApply(type, contract) {
      applyType.value = type;
      applyPreset.value = {
        contractId: contract.id,
        contractName: contract.contractName,
        contractNo: contract.contractNo,
        wealthCustomerId: contract.wealthCustomerId
      };
      applyVisible.value = true;
    }
    function openRollover(contract, batch) {
      applyType.value = 'ROLLOVER';
      applyPreset.value = {
        contractId: contract.id,
        contractName: contract.contractName,
        contractNo: contract.contractNo,
        wealthCustomerId: contract.wealthCustomerId,
        batchId: batch.id,
        batchNo: batch.batchNo
      };
      applyVisible.value = true;
    }
    function afterCustomerSaved() {
      loadCustomers();
      loadStatistics();
    }
    async function afterApplySubmitted() {
      loadStatistics();
      if (selectedCustomer.value?.id) {
        await Promise.all([loadAccount(selectedCustomer.value.id), loadContracts(), loadApplies()]);
        if (expandedContractId.value) {
          await loadOngoingOperationsForContract(expandedContractId.value);
        }
      }
    }
    watch(activeTab, value => {
      if (value === 'contracts' && contracts.value.length === 0) loadContracts();
      if (value === 'ledgers' && ledgers.value.length === 0) loadLedgers();
      if (value === 'applies' && applies.value.length === 0) loadApplies();
    });
    onMounted(() => {
      loadCustomers();
      loadStatistics();
      document.addEventListener('visibilitychange', handleCustomerPageAutoRefresh);
      window.addEventListener('focus', handleCustomerPageAutoRefresh);
    });
    onBeforeUnmount(() => {
      document.removeEventListener('visibilitychange', handleCustomerPageAutoRefresh);
      window.removeEventListener('focus', handleCustomerPageAutoRefresh);
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "财富客户"), _createElementVNode("p", {
          class: "list-page-description"
        }, "以客户为主体查看合同、批次、流水和申请记录。")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary inline-flex items-center gap-2",
          disabled: statisticsLoading.value,
          onClick: loadStatistics
        }, [(_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass(["h-4 w-4", {
            'animate-spin': statisticsLoading.value
          }]),
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [...(_cache[18] || (_cache[18] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        }, null, -1)]))], 2)), _cache[19] || (_cache[19] = _createTextVNode(" 刷新摘要 ", -1))], 8, _hoisted_4)])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(WealthMetricCard, {
          title: "财富客户数",
          value: overview.value.customerCount || 0,
          description: "授权范围内客户"
        }, null, 8, ["value"]), _createVNode(WealthMetricCard, {
          title: "当前总本金",
          value: `¥${_unref(formatMoney)(overview.value.currentPrincipalAmount)}`,
          description: "有效及已到期未处理批次"
        }, null, 8, ["value"]), _createVNode(WealthMetricCard, {
          title: "即将到期",
          value: `${overview.value.upcomingMaturityBatchCount || 0} 批`,
          description: `金额 ¥${_unref(formatMoney)(overview.value.upcomingMaturityAmount)}`,
          tone: "amber"
        }, null, 8, ["value", "description"]), _createVNode(WealthMetricCard, {
          title: "已到期未处理",
          value: `${overview.value.maturedUnhandledBatchCount || 0} 批`,
          description: `金额 ¥${_unref(formatMoney)(overview.value.maturedUnhandledAmount)}`,
          tone: "red"
        }, null, 8, ["value", "description"])]), _createElementVNode("div", _hoisted_6, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: refreshCustomerListAndStatistics
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            class: "btn-primary",
            onClick: openCreate
          }, [...(_cache[22] || (_cache[22] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新建客户 ", -1)]))])), [[_directive_permission, 'wealth:customer:create']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.keyword = $event),
            class: "form-search-input form-control-sm w-full",
            placeholder: "姓名/手机号/证件号",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, filters.keyword]]), _cache[21] || (_cache[21] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: filters.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customerStatusOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: filters.riskLevel,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.riskLevel = $event),
            placeholder: "请选择风险等级",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部风险等级",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(riskLevelOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(UserSelector, {
            modelValue: filters.ownerUserId,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.ownerUserId = $event),
            class: "selector-compact filter-bar-field",
            multiple: false,
            placeholder: "选择负责人"
          }, null, 8, ["modelValue"]), _createVNode(DeptSelector, {
            modelValue: filters.ownerDept,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filters.ownerDept = $event),
            class: "selector-compact filter-bar-field",
            multiple: false,
            placeholder: "选择部门"
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("table", _hoisted_10, [_cache[31] || (_cache[31] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "客户"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "联系方式"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "证件"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "负责人"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "风险等级"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "创建时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, m => {
            return _createElementVNode("td", {
              key: m,
              class: _normalizeClass(["data-table-td", m === 8 ? 'data-table-sticky-right data-table-sticky-action' : ''])
            }, [...(_cache[23] || (_cache[23] = [_createElementVNode("div", {
              class: "h-4 bg-slate-200 rounded w-24"
            }, null, -1)]))], 2);
          }), 64))]);
        }), 64)) : rows.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [...(_cache[24] || (_cache[24] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, "暂无财富客户", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(rows.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(row.name), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(row.customerNo || '-'), 1)]), _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(maskPhone)(row.mobile)), 1), _createElementVNode("td", _hoisted_16, [_createElementVNode("div", null, _toDisplayString(_unref(findOptionLabel)(_unref(idTypeOptions), row.idType)), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(maskIdNo)(row.idNo)), 1)]), _createElementVNode("td", _hoisted_18, [_createElementVNode("div", null, _toDisplayString(row.ownerUserName || row.ownerUserId || '-'), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(row.ownerDeptName || row.ownerDeptId || '-'), 1)]), _createElementVNode("td", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(WealthStatusBadge, {
            type: "risk",
            value: row.riskLevel
          }, null, 8, ["value"])])]), _createElementVNode("td", _hoisted_22, [_createVNode(WealthStatusBadge, {
            type: "customer",
            value: row.status,
            "show-dot": ""
          }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(formatDateTime)(row.createTime)), 1), _createElementVNode("td", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "详情",
            "aria-label": "详情",
            onClick: $event => openDetail(row)
          }, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_26), _createVNode(_component_el_dropdown, {
            trigger: "click",
            "hide-on-click": true
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [row.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 0,
                onClick: $event => openInvest(row)
              }, {
                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode("注资", -1)]))]),
                _: 1
              }, 8, ["onClick"])), [[_directive_permission, 'wealth:fund:invest']]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, {
                onClick: $event => openEdit(row)
              }, {
                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode("编辑", -1)]))]),
                _: 1
              }, 8, ["onClick"])), [[_directive_permission, 'wealth:customer:update']]), row.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 1,
                divided: "",
                onClick: $event => changeStatus(row, 'disable')
              }, {
                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createElementVNode("span", {
                  class: "text-red-600"
                }, "停用", -1)]))]),
                _: 1
              }, 8, ["onClick"])), [[_directive_permission, 'wealth:customer:disable']]) : _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 2,
                divided: "",
                onClick: $event => changeStatus(row, 'enable')
              }, {
                default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createTextVNode("启用", -1)]))]),
                _: 1
              }, 8, ["onClick"])), [[_directive_permission, 'wealth:customer:update']])]),
              _: 2
            }, 1024)]),
            default: _withCtx(() => [_createElementVNode("button", {
              class: "table-action-button is-neutral",
              title: "更多",
              "aria-label": "更多操作",
              onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
            }, [...(_cache[26] || (_cache[26] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm6 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm6 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
            })], -1)]))])]),
            _: 2
          }, 1024)])])]);
        }), 128))])])])]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pagination,
          "page-sizes": _unref(PAGE_SIZE_OPTIONS),
          onPageChange: handlePageChange,
          onSizeChange: handleSizeChange
        }, null, 8, ["pagination", "page-sizes"])) : _createCommentVNode("", true)]), _createVNode(WealthCustomerFormModal, {
          modelValue: formVisible.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formVisible.value = $event),
          customer: editingCustomer.value,
          onSaved: afterCustomerSaved
        }, null, 8, ["modelValue", "customer"]), _createVNode(WealthOperationApplyModal, {
          modelValue: applyVisible.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => applyVisible.value = $event),
          "operation-type": applyType.value,
          preset: applyPreset.value,
          onSubmitted: afterApplySubmitted
        }, null, 8, ["modelValue", "operation-type", "preset"]), _createVNode(WealthDetailDrawer, {
          modelValue: detailVisible.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => detailVisible.value = $event),
          title: "财富客户详情",
          subtitle: selectedCustomer.value?.customerNo
        }, {
          default: _withCtx(() => [selectedCustomer.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("section", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_30, _toDisplayString(selectedCustomer.value.name), 1), _createElementVNode("div", _hoisted_31, [_createVNode(WealthStatusBadge, {
            type: "customer",
            value: selectedCustomer.value.status,
            "show-dot": ""
          }, null, 8, ["value"]), _createVNode(WealthStatusBadge, {
            type: "risk",
            value: selectedCustomer.value.riskLevel
          }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_32, [_withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            class: "btn-primary",
            onClick: _cache[8] || (_cache[8] = $event => openInvest(selectedCustomer.value))
          }, [...(_cache[32] || (_cache[32] = [_createTextVNode("注资", -1)]))])), [[_directive_permission, 'wealth:fund:invest']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[9] || (_cache[9] = $event => openEdit(selectedCustomer.value))
          }, [...(_cache[33] || (_cache[33] = [_createTextVNode("编辑客户", -1)]))])), [[_directive_permission, 'wealth:customer:update']])])])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_cache[34] || (_cache[34] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "当前本金", -1)), _createElementVNode("div", _hoisted_35, "¥" + _toDisplayString(_unref(formatMoney)(account.value.currentPrincipalAmount)), 1)]), _createElementVNode("div", _hoisted_36, [_cache[35] || (_cache[35] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "累计注资", -1)), _createElementVNode("div", _hoisted_37, "¥" + _toDisplayString(_unref(formatMoney)(account.value.totalInvestAmount)), 1)]), _createElementVNode("div", _hoisted_38, [_cache[36] || (_cache[36] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "累计增资", -1)), _createElementVNode("div", _hoisted_39, "¥" + _toDisplayString(_unref(formatMoney)(account.value.totalIncreaseAmount)), 1)]), _createElementVNode("div", _hoisted_40, [_cache[37] || (_cache[37] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "累计撤资", -1)), _createElementVNode("div", _hoisted_41, "¥" + _toDisplayString(_unref(formatMoney)(account.value.totalWithdrawAmount)), 1)])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("nav", _hoisted_43, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(detailTabs, tab => {
            return _createElementVNode("button", {
              key: tab.value,
              type: "button",
              class: _normalizeClass(["border-b-2 px-1 py-3 font-medium transition-colors", activeTab.value === tab.value ? 'border-primary-500 text-primary-600' : 'border-transparent text-slate-500 hover:text-slate-700']),
              onClick: $event => activeTab.value = tab.value
            }, _toDisplayString(tab.label), 11, _hoisted_44);
          }), 64))])]), _withDirectives(_createElementVNode("section", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createVNode(_unref(FieldBlock), {
            label: "手机号",
            value: _unref(maskPhone)(selectedCustomer.value.mobile)
          }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
            label: "证件",
            value: `${_unref(findOptionLabel)(_unref(idTypeOptions), selectedCustomer.value.idType)} ${_unref(maskIdNo)(selectedCustomer.value.idNo)}`
          }, null, 8, ["value"]), selectedCustomer.value.linkedCrmCustomerId ? (_openBlock(), _createBlock(_unref(FieldBlock), {
            key: 0,
            label: "关联 CRM 客户",
            value: linkedCrmCustomerDisplay.value
          }, null, 8, ["value"])) : _createCommentVNode("", true), _createVNode(_unref(FieldBlock), {
            label: "负责人",
            value: selectedCustomer.value.ownerUserName || selectedCustomer.value.ownerUserId || '-'
          }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
            label: "所属部门",
            value: selectedCustomer.value.ownerDeptName || selectedCustomer.value.ownerDeptId || '-'
          }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
            label: "地址",
            value: selectedCustomer.value.address || '-'
          }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
            label: "紧急联系人",
            value: selectedCustomer.value.emergencyContactName || '-'
          }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
            label: "紧急联系电话",
            value: _unref(maskPhone)(selectedCustomer.value.emergencyContactMobile)
          }, null, 8, ["value"]), _createVNode(_unref(FieldBlock), {
            label: "备注",
            value: selectedCustomer.value.remark || '-'
          }, null, 8, ["value"])])], 512), [[_vShow, activeTab.value === 'overview']]), _withDirectives(_createElementVNode("section", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_cache[38] || (_cache[38] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "客户合同", -1)), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: contractsLoading.value,
            onClick: loadContracts
          }, "刷新", 8, _hoisted_50)]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("table", _hoisted_53, [_cache[47] || (_cache[47] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "合同"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "当前本金"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "注资日期"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "状态"), _createElementVNode("th", {
            class: "data-table-th text-center"
          }, "操作")])], -1)), _createElementVNode("tbody", null, [contractsLoading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [...(_cache[39] || (_cache[39] = [_createElementVNode("td", {
            colspan: "5",
            class: "data-table-empty"
          }, "加载中...", -1)]))])) : contracts.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [...(_cache[40] || (_cache[40] = [_createElementVNode("td", {
            colspan: "5",
            class: "data-table-empty"
          }, "暂无合同", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 2
          }, _renderList(contracts.value, item => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [_createElementVNode("tr", _hoisted_56, [_createElementVNode("td", _hoisted_57, [_createElementVNode("button", {
              type: "button",
              class: "text-left font-medium text-primary-600 hover:text-primary-700",
              onClick: $event => toggleContract(item)
            }, _toDisplayString(item.contractName), 9, _hoisted_58), _createElementVNode("div", _hoisted_59, _toDisplayString(item.contractNo), 1), contractOngoingOperationMap.value[item.id]?.length ? (_openBlock(), _createElementBlock("div", _hoisted_60, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractOngoingOperationMap.value[item.id], operation => {
              return _openBlock(), _createElementBlock("div", {
                key: `row-${operation.applyId}`,
                class: "inline-flex items-center gap-1"
              }, [_createElementVNode("button", {
                type: "button",
                class: "rounded-full status-badge is-warning px-2 py-0.5 text-xs font-medium ring-1 ring-amber-200 hover:bg-amber-100",
                onClick: _withModifiers($event => openOngoingOperationDetail(operation), ["stop"])
              }, _toDisplayString(formatOngoingOperationSummary(operation)), 9, _hoisted_61), operation.apply?.approvalInstanceId ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "table-action-button is-purple",
                title: "查看审批详情",
                "aria-label": "查看审批详情",
                onClick: _withModifiers($event => openOngoingOperationApprovalDetail(operation), ["stop"])
              }, [...(_cache[41] || (_cache[41] = [_createElementVNode("svg", {
                class: "h-3.5 w-3.5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
              })], -1)]))], 8, _hoisted_62)) : _createCommentVNode("", true)]);
            }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_63, "¥" + _toDisplayString(_unref(formatMoney)(item.currentPrincipalAmount)), 1), _createElementVNode("td", _hoisted_64, _toDisplayString(_unref(formatDate)(item.signDate)), 1), _createElementVNode("td", _hoisted_65, [_createVNode(WealthStatusBadge, {
              type: "contract",
              value: item.status,
              "show-dot": ""
            }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_66, [_createElementVNode("div", _hoisted_67, [item.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "table-action-button is-success",
              title: "增资",
              "aria-label": "增资",
              onClick: $event => openContractApply('INCREASE', item)
            }, [...(_cache[42] || (_cache[42] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"
            })], -1)]))], 8, _hoisted_68)), [[_directive_permission, 'wealth:fund:increase']]) : _createCommentVNode("", true), item.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "table-action-button is-warning",
              title: "减资",
              "aria-label": "减资",
              onClick: $event => openContractApply('DECREASE', item)
            }, [...(_cache[43] || (_cache[43] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M2.25 6L9 12.75l4.286-4.286a11.948 11.948 0 014.306 6.43l.776 2.898m0 0l3.182-5.511m-3.182 5.51l-5.511-3.181"
            })], -1)]))], 8, _hoisted_69)), [[_directive_permission, 'wealth:fund:decrease']]) : _createCommentVNode("", true), item.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 2,
              class: "table-action-button is-danger",
              title: "撤资",
              "aria-label": "撤资",
              onClick: $event => openContractApply('WITHDRAW', item)
            }, [...(_cache[44] || (_cache[44] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M17 16l4-4m0 0l-4-4m4 4H7"
            })], -1)]))], 8, _hoisted_70)), [[_directive_permission, 'wealth:fund:withdraw']]) : _createCommentVNode("", true)])])]), expandedContractId.value === item.id ? (_openBlock(), _createElementBlock("tr", _hoisted_71, [_createElementVNode("td", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_createVNode(WealthBatchPanel, {
              "contract-id": item.id,
              title: "合同批次",
              "show-mode-switch": false,
              "ongoing-operations": batchOngoingOperationMap.value,
              onViewOperation: openOngoingOperationDetail,
              onViewApproval: openOngoingOperationApprovalDetail
            }, {
              actions: _withCtx(({
                row
              }) => [_createElementVNode("div", _hoisted_74, [_withDirectives((_openBlock(), _createElementBlock("button", {
                class: "table-action-button is-primary",
                title: "批次流水",
                "aria-label": "批次流水",
                onClick: $event => openBatchLedgerDetail(row)
              }, [...(_cache[45] || (_cache[45] = [_createElementVNode("svg", {
                class: "h-4 w-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 6h16M4 12h16M4 18h16"
              })], -1)]))], 8, _hoisted_75)), [[_directive_permission, 'wealth:ledger:view']]), item.status === 'ACTIVE' ? _withDirectives((_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "table-action-button is-indigo",
                title: "续期",
                "aria-label": "续期",
                onClick: $event => openRollover(item, row)
              }, [...(_cache[46] || (_cache[46] = [_createElementVNode("svg", {
                class: "h-4 w-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M16 3h5v5"
              }), _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M21 8a9 9 0 00-15.5-3.5"
              }), _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M8 21H3v-5"
              }), _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M3 16a9 9 0 0015.5 3.5"
              })], -1)]))], 8, _hoisted_76)), [[_directive_permission, 'wealth:fund:rollover']]) : _createCommentVNode("", true)])]),
              _: 2
            }, 1032, ["contract-id", "ongoing-operations"]), _createVNode(WealthAttachmentPanel, {
              title: "合同附件",
              "biz-type": "CONTRACT",
              "biz-id": item.id,
              "can-manage": true
            }, null, 8, ["biz-id"])])])])) : _createCommentVNode("", true)], 64);
          }), 128))])])])]), contractPagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
            key: 0,
            class: "pagination-bridge px-4 pb-4 wealth-contract-pagination-sticky",
            pagination: contractPagination,
            "page-sizes": _unref(PAGE_SIZE_OPTIONS),
            onPageChange: handleContractPageChange,
            onSizeChange: handleContractSizeChange
          }, null, 8, ["pagination", "page-sizes"])) : _createCommentVNode("", true)])], 512), [[_vShow, activeTab.value === 'contracts']]), _withDirectives(_createElementVNode("section", _hoisted_77, [_createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_cache[48] || (_cache[48] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "客户流水", -1)), _createElementVNode("div", _hoisted_80, [_createVNode(_component_el_select, {
            modelValue: ledgerFilters.operationType,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ledgerFilters.operationType = $event),
            placeholder: "请选择类型",
            class: "form-select form-control-sm w-60"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operationTypeOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: ledgersLoading.value,
            onClick: loadLedgers
          }, "搜索", 8, _hoisted_81)])]), _createElementVNode("div", _hoisted_82, [_createElementVNode("div", _hoisted_83, [_createElementVNode("table", _hoisted_84, [_cache[52] || (_cache[52] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "流水"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "类型"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "方向"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "合同/批次"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "金额"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "账户本金前后"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "时间"), _createElementVNode("th", {
            class: "data-table-th text-center"
          }, "操作")])], -1)), _createElementVNode("tbody", null, [ledgersLoading.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(3, n => {
            return _createElementVNode("tr", {
              key: n,
              class: "animate-pulse"
            }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, m => {
              return _createElementVNode("td", {
                key: m,
                class: "data-table-td"
              }, [...(_cache[49] || (_cache[49] = [_createElementVNode("div", {
                class: "h-4 bg-slate-200 rounded w-24"
              }, null, -1)]))]);
            }), 64))]);
          }), 64)) : ledgers.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_85, [...(_cache[50] || (_cache[50] = [_createElementVNode("td", {
            colspan: "8",
            class: "data-table-empty"
          }, "暂无流水", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 2
          }, _renderList(ledgers.value, row => {
            return _openBlock(), _createElementBlock("tr", {
              key: row.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_86, [_createElementVNode("div", _hoisted_87, _toDisplayString(row.ledgerNo), 1), _createElementVNode("div", _hoisted_88, _toDisplayString(row.accountingSerialNo), 1)]), _createElementVNode("td", _hoisted_89, [_createVNode(WealthStatusBadge, {
              type: "operation",
              value: row.operationType
            }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_90, [_createVNode(WealthStatusBadge, {
              type: "direction",
              value: row.direction
            }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_91, [_createElementVNode("div", null, "合同 " + _toDisplayString(row.contractId || '-'), 1), _createElementVNode("div", _hoisted_92, "批次 " + _toDisplayString(row.batchId || '-'), 1)]), _createElementVNode("td", {
              class: _normalizeClass(["data-table-td is-right money-text", row.direction === 'OUT' ? 'text-red-600' : 'text-emerald-600'])
            }, _toDisplayString(row.direction === 'OUT' ? '-' : '+') + "¥" + _toDisplayString(_unref(formatMoney)(row.amount)), 3), _createElementVNode("td", _hoisted_93, "¥" + _toDisplayString(_unref(formatMoney)(row.beforeAccountPrincipal)) + " → ¥" + _toDisplayString(_unref(formatMoney)(row.afterAccountPrincipal)), 1), _createElementVNode("td", _hoisted_94, _toDisplayString(_unref(formatDateTime)(row.createTime)), 1), _createElementVNode("td", _hoisted_95, [_createElementVNode("button", {
              class: "table-action-button is-primary",
              title: "明细",
              "aria-label": "明细",
              onClick: $event => openLedgerDetail(row)
            }, [...(_cache[51] || (_cache[51] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 6h16M4 12h16M4 18h16"
            })], -1)]))], 8, _hoisted_96)])]);
          }), 128))])])])]), ledgerPagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
            key: 0,
            class: "pagination-bridge px-4 pb-4",
            pagination: ledgerPagination,
            "page-sizes": _unref(PAGE_SIZE_OPTIONS),
            onPageChange: handleLedgerPageChange,
            onSizeChange: handleLedgerSizeChange
          }, null, 8, ["pagination", "page-sizes"])) : _createCommentVNode("", true)])], 512), [[_vShow, activeTab.value === 'ledgers']]), _withDirectives(_createElementVNode("section", _hoisted_97, [_createElementVNode("div", _hoisted_98, [_createElementVNode("div", _hoisted_99, [_cache[53] || (_cache[53] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "申请记录", -1)), _createElementVNode("div", _hoisted_100, [_createVNode(_component_el_select, {
            modelValue: applyFilters.status,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => applyFilters.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm w-60"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(applyStatusOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: appliesLoading.value,
            onClick: loadApplies
          }, "搜索", 8, _hoisted_101)])]), _createElementVNode("div", _hoisted_102, [_createElementVNode("div", _hoisted_103, [_createElementVNode("table", _hoisted_104, [_cache[58] || (_cache[58] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "申请"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "类型"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "金额"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "状态"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "申请时间"), _createElementVNode("th", {
            class: "data-table-th text-center"
          }, "操作")])], -1)), _createElementVNode("tbody", null, [appliesLoading.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(3, n => {
            return _createElementVNode("tr", {
              key: n,
              class: "animate-pulse"
            }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, m => {
              return _createElementVNode("td", {
                key: m,
                class: "data-table-td"
              }, [...(_cache[54] || (_cache[54] = [_createElementVNode("div", {
                class: "h-4 bg-slate-200 rounded w-24"
              }, null, -1)]))]);
            }), 64))]);
          }), 64)) : applies.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_105, [...(_cache[55] || (_cache[55] = [_createElementVNode("td", {
            colspan: "6",
            class: "data-table-empty"
          }, "暂无申请记录", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 2
          }, _renderList(applies.value, row => {
            return _openBlock(), _createElementBlock("tr", {
              key: row.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_106, [_createElementVNode("div", _hoisted_107, _toDisplayString(row.applyNo), 1), _createElementVNode("div", _hoisted_108, [_createElementVNode("span", null, "实例 " + _toDisplayString(row.approvalInstanceId || '-'), 1), row.approvalInstanceId ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "inline-approval-link rounded px-1 text-primary-600 transition-colors hover:bg-primary-50 hover:text-primary-700",
              onClick: _withModifiers($event => openApprovalDetail(row), ["stop"])
            }, " 审批详情 ", 8, _hoisted_109)) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_110, [_createVNode(WealthStatusBadge, {
              type: "operation",
              value: row.operationType
            }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_111, "¥" + _toDisplayString(_unref(formatMoney)(row.rolloverPrincipalAmount || row.amount)), 1), _createElementVNode("td", _hoisted_112, [_createVNode(WealthStatusBadge, {
              type: "apply",
              value: row.status,
              "show-dot": ""
            }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_113, _toDisplayString(_unref(formatDateTime)(row.applyTime)), 1), _createElementVNode("td", _hoisted_114, [_createElementVNode("div", _hoisted_115, [_createElementVNode("button", {
              class: "table-action-button is-primary",
              title: "详情",
              "aria-label": "详情",
              onClick: $event => openApplyDetail(row)
            }, [...(_cache[56] || (_cache[56] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            }), _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            })], -1)]))], 8, _hoisted_116), row.approvalInstanceId ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "table-action-button is-purple",
              title: "查看审批详情",
              "aria-label": "查看审批详情",
              onClick: $event => openApprovalDetail(row)
            }, [...(_cache[57] || (_cache[57] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
            })], -1)]))], 8, _hoisted_117)) : _createCommentVNode("", true)])])]);
          }), 128))])])])]), applyPagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
            key: 0,
            class: "pagination-bridge px-4 pb-4",
            pagination: applyPagination,
            "page-sizes": _unref(PAGE_SIZE_OPTIONS),
            onPageChange: handleApplyPageChange,
            onSizeChange: handleApplySizeChange
          }, null, 8, ["pagination", "page-sizes"])) : _createCommentVNode("", true)])], 512), [[_vShow, activeTab.value === 'applies']])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue", "subtitle"]), _createVNode(WealthDetailDrawer, {
          modelValue: ledgerDetailVisible.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ledgerDetailVisible.value = $event),
          title: "流水详情",
          subtitle: selectedLedger.value?.ledgerNo
        }, {
          default: _withCtx(() => [selectedLedger.value ? (_openBlock(), _createElementBlock("div", _hoisted_118, [_createElementVNode("section", _hoisted_119, [_createElementVNode("div", null, [_cache[59] || (_cache[59] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "操作类型", -1)), _createVNode(WealthStatusBadge, {
            type: "operation",
            value: selectedLedger.value.operationType
          }, null, 8, ["value"])]), _createElementVNode("div", null, [_cache[60] || (_cache[60] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "方向", -1)), _createVNode(WealthStatusBadge, {
            type: "direction",
            value: selectedLedger.value.direction
          }, null, 8, ["value"])]), _createElementVNode("div", null, [_cache[61] || (_cache[61] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "金额", -1)), _createElementVNode("div", _hoisted_120, "¥" + _toDisplayString(_unref(formatMoney)(selectedLedger.value.amount)), 1)]), _createElementVNode("div", null, [_cache[62] || (_cache[62] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "备注", -1)), _createElementVNode("div", null, _toDisplayString(selectedLedger.value.remark || '-'), 1)])]), _createElementVNode("section", _hoisted_121, [_cache[65] || (_cache[65] = _createElementVNode("div", {
            class: "border-b border-slate-200 px-4 py-3"
          }, [_createElementVNode("h4", {
            class: "text-sm font-semibold"
          }, "批次明细")], -1)), _createElementVNode("div", _hoisted_122, [_createElementVNode("div", _hoisted_123, [_createElementVNode("table", _hoisted_124, [_cache[64] || (_cache[64] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "批次ID"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "金额"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "批次本金前后")])], -1)), _createElementVNode("tbody", null, [ledgerDetails.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_125, [...(_cache[63] || (_cache[63] = [_createElementVNode("td", {
            colspan: "3",
            class: "data-table-empty"
          }, "暂无明细", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(ledgerDetails.value, item => {
            return _openBlock(), _createElementBlock("tr", {
              key: item.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_126, _toDisplayString(item.batchId), 1), _createElementVNode("td", _hoisted_127, "¥" + _toDisplayString(_unref(formatMoney)(item.amount)), 1), _createElementVNode("td", _hoisted_128, "¥" + _toDisplayString(_unref(formatMoney)(item.beforeBatchPrincipal)) + " → ¥" + _toDisplayString(_unref(formatMoney)(item.afterBatchPrincipal)), 1)]);
          }), 128))])])])])])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue", "subtitle"]), _createVNode(WealthDetailDrawer, {
          modelValue: batchLedgerVisible.value,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => batchLedgerVisible.value = $event),
          title: "批次流水",
          subtitle: selectedBatchLedgerBatch.value?.batchNo
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_129, [_createElementVNode("section", _hoisted_130, [_createElementVNode("div", _hoisted_131, [_cache[66] || (_cache[66] = _createElementVNode("div", null, [_createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "批次资金轨迹"), _createElementVNode("p", {
            class: "mt-0.5 text-xs text-slate-500"
          }, "按当前批次关联流水展示，减资、撤资等多批次流水以明细表口径匹配。")], -1)), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            disabled: batchLedgersLoading.value,
            onClick: loadBatchLedgers
          }, "刷新", 8, _hoisted_132)]), _createElementVNode("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, [_createElementVNode("table", _hoisted_135, [_cache[70] || (_cache[70] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "流水"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "类型"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "方向"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "金额"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "时间"), _createElementVNode("th", {
            class: "data-table-th text-center"
          }, "操作")])], -1)), _createElementVNode("tbody", null, [batchLedgersLoading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_136, [...(_cache[67] || (_cache[67] = [_createElementVNode("td", {
            colspan: "6",
            class: "data-table-empty"
          }, "加载中...", -1)]))])) : batchLedgers.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_137, [...(_cache[68] || (_cache[68] = [_createElementVNode("td", {
            colspan: "6",
            class: "data-table-empty"
          }, "暂无批次流水", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 2
          }, _renderList(batchLedgers.value, row => {
            return _openBlock(), _createElementBlock("tr", {
              key: row.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_138, [_createElementVNode("div", _hoisted_139, _toDisplayString(row.ledgerNo), 1), _createElementVNode("div", _hoisted_140, _toDisplayString(row.accountingSerialNo), 1)]), _createElementVNode("td", _hoisted_141, [_createVNode(WealthStatusBadge, {
              type: "operation",
              value: row.operationType
            }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_142, [_createVNode(WealthStatusBadge, {
              type: "direction",
              value: row.direction
            }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_143, "¥" + _toDisplayString(_unref(formatMoney)(row.amount)), 1), _createElementVNode("td", _hoisted_144, _toDisplayString(_unref(formatDateTime)(row.createTime)), 1), _createElementVNode("td", _hoisted_145, [_createElementVNode("button", {
              class: "table-action-button is-primary",
              title: "明细",
              "aria-label": "明细",
              onClick: $event => openLedgerDetail(row)
            }, [...(_cache[69] || (_cache[69] = [_createElementVNode("svg", {
              class: "h-4 w-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 6h16M4 12h16M4 18h16"
            })], -1)]))], 8, _hoisted_146)])]);
          }), 128))])])])]), batchLedgerPagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
            key: 0,
            class: "pagination-bridge px-4 pb-4",
            pagination: batchLedgerPagination,
            "page-sizes": _unref(PAGE_SIZE_OPTIONS),
            onPageChange: handleBatchLedgerPageChange,
            onSizeChange: handleBatchLedgerSizeChange
          }, null, 8, ["pagination", "page-sizes"])) : _createCommentVNode("", true)])])]),
          _: 1
        }, 8, ["modelValue", "subtitle"]), _createVNode(WealthDetailDrawer, {
          modelValue: applyDetailVisible.value,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => applyDetailVisible.value = $event),
          title: "资金申请详情",
          subtitle: selectedApply.value?.applyNo
        }, {
          default: _withCtx(() => [selectedApply.value ? (_openBlock(), _createElementBlock("div", _hoisted_147, [_createElementVNode("div", _hoisted_148, [selectedApply.value.approvalInstanceId ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn-secondary inline-flex items-center gap-1.5",
            onClick: _cache[15] || (_cache[15] = $event => openApprovalDetail(selectedApply.value))
          }, [...(_cache[71] || (_cache[71] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          })], -1), _createTextVNode(" 查看审批详情 ", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("section", _hoisted_149, [_createElementVNode("div", null, [_cache[72] || (_cache[72] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "操作类型", -1)), _createVNode(WealthStatusBadge, {
            type: "operation",
            value: selectedApply.value.operationType
          }, null, 8, ["value"])]), _createElementVNode("div", null, [_cache[73] || (_cache[73] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "状态", -1)), _createVNode(WealthStatusBadge, {
            type: "apply",
            value: selectedApply.value.status
          }, null, 8, ["value"])]), _createElementVNode("div", null, [_cache[74] || (_cache[74] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "申请金额", -1)), _createElementVNode("div", _hoisted_150, "¥" + _toDisplayString(_unref(formatMoney)(selectedApply.value.amount)), 1)]), _createElementVNode("div", null, [_cache[75] || (_cache[75] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "续期本金", -1)), _createElementVNode("div", _hoisted_151, "¥" + _toDisplayString(_unref(formatMoney)(selectedApply.value.rolloverPrincipalAmount)), 1)]), _createElementVNode("div", null, [_cache[76] || (_cache[76] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "合同ID", -1)), _createElementVNode("div", null, _toDisplayString(selectedApply.value.contractId || '-'), 1)]), _createElementVNode("div", null, [_cache[77] || (_cache[77] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "审批实例", -1)), _createElementVNode("div", null, _toDisplayString(selectedApply.value.approvalInstanceId || '-'), 1)]), _createElementVNode("div", null, [_cache[78] || (_cache[78] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "申请人", -1)), _createElementVNode("div", null, _toDisplayString(selectedApply.value.applicantName || selectedApply.value.applicantUserId || '-'), 1)]), _createElementVNode("div", null, [_cache[79] || (_cache[79] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "失败原因", -1)), _createElementVNode("div", _hoisted_152, _toDisplayString(selectedApply.value.accountFailedReason || selectedApply.value.approvalStartFailedReason || '-'), 1)])]), _createElementVNode("section", _hoisted_153, [_cache[82] || (_cache[82] = _createElementVNode("div", {
            class: "border-b border-slate-200 px-4 py-3"
          }, [_createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "批次明细")], -1)), _createElementVNode("div", _hoisted_154, [_createElementVNode("div", _hoisted_155, [_createElementVNode("table", _hoisted_156, [_cache[81] || (_cache[81] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "批次"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "金额"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "提交前本金"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "起止日期")])], -1)), _createElementVNode("tbody", null, [applyDetails.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_157, [...(_cache[80] || (_cache[80] = [_createElementVNode("td", {
            colspan: "4",
            class: "data-table-empty"
          }, "暂无明细", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(applyDetails.value, item => {
            return _openBlock(), _createElementBlock("tr", {
              key: item.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_158, [_createElementVNode("div", _hoisted_159, _toDisplayString(item.batchNoSnapshot || item.batchId), 1)]), _createElementVNode("td", _hoisted_160, "¥" + _toDisplayString(_unref(formatMoney)(item.amount)), 1), _createElementVNode("td", _hoisted_161, "¥" + _toDisplayString(_unref(formatMoney)(item.beforeBatchPrincipalSnapshot)), 1), _createElementVNode("td", _hoisted_162, _toDisplayString(_unref(formatDate)(item.valueDateSnapshot)) + " 至 " + _toDisplayString(_unref(formatDate)(item.maturityDateSnapshot)), 1)]);
          }), 128))])])])])]), _createVNode(WealthAttachmentPanel, {
            title: "申请附件",
            "biz-type": "OPERATION_APPLY",
            "biz-id": selectedApply.value.id,
            "can-manage": false
          }, null, 8, ["biz-id"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue", "subtitle"]), _createVNode(ApprovalDetailModal, {
          modelValue: showApprovalDetailModal.value,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => showApprovalDetailModal.value = $event),
          "instance-id": selectedApprovalInstanceId.value,
          type: 'wealth',
          title: "审批详情"
        }, null, 8, ["modelValue", "instance-id"])]),
        _: 1
      });
    };
  }
};